import { render, staticRenderFns } from "./authCopy.vue?vue&type=template&id=5620e72c&scoped=true"
import script from "./authCopy.vue?vue&type=script&lang=js"
export * from "./authCopy.vue?vue&type=script&lang=js"
import style0 from "./authCopy.vue?vue&type=style&index=0&id=5620e72c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620e72c",
  null
  
)

export default component.exports